/* @flow */

import React from 'react';
import _ from 'lodash';
// import cx from 'classnames';
import { Col } from 'reactstrap';
import { connect } from 'react-redux';
import { compose, withHandlers, withState } from 'recompose';

import { actions as designActions } from '../../actions/design';
import { actions as modalActions, constants as modalConstants } from '../../actions/modal';
import { getDesignName, getCurrentRecordId } from '../../selectors/global';
import * as progressSelectors from '../../selectors/progress';
import RightToolBar from '../RightToolBar';
import LeftToolBar from '../LeftToolBar';

import designRoutines from '../../routines/design';

import classes from './DesignToolBar.scss';

type PropsType = {
  designName: string,
  disableAutoComplete: boolean,
  disableBack: boolean,
  disableNext: boolean,
  disableOpen: boolean,
  disableRedo: boolean,
  disableReset: boolean,
  disableSave: boolean,
  disableUndo: boolean,
  onAutoComplete: Function,
  onNewDesign: Function,
  onOpen: Function,
  onRedo: Function,
  onSave: Function,
  onStepBackward: Function,
  onStepForward: Function,
  onStepReset: Function,
  onUndo: Function,
};

export class DesignToolBar extends React.PureComponent<PropsType, *> {
  props: PropsType;

  render() {
    return (
      <Col className={classes.navWrapper} >
        <div className="d-lg-flex justify-content-start">
          <LeftToolBar {..._.omit(this.props, ['disableReset', 'disableAutoComplete'])} />
          <RightToolBar {...this.props} />
        </div>
      </Col>
    );
  }
}

function mapStateToProps(state: any) {
  const designName: string = getDesignName(state);
  const id = getCurrentRecordId(state);
  const isSavedDesign = id !== null;

  return {
    disableOpen: false,
    disableSave: false,
    disableNext: !progressSelectors.getNextEnabled(state),
    disableBack: !progressSelectors.getBackEnabled(state),
    disableReset: !progressSelectors.getResetEnabled(state),
    disableRename: false,
    disableAutoComplete: !progressSelectors.getAutocompleteEnabled(state),
    designName,
    isSavedDesign,
    id,
  };
}

const enhancer = compose(
  connect(mapStateToProps),
  withState('designTitle', 'setTitle', props => props.designName),
  withHandlers({
    onChangeDesignName: ({ setTitle }) => () => setTitle(s => s),
    onAutoComplete: props => () => props.dispatch(designActions.autoComplete()),
    onNewDesign: props => () => props.dispatch(designActions.newDesign()),
    onOpen: props => () => props.dispatch(designActions.openDesign()),
    // onRedo: props => () => props.dispatch(designActions.())),
    onSave: props => () => props.dispatch(
      modalActions.showModal({
        modalType: modalConstants.MODAL_SAVE_DESIGN,
        modalProps: {
          onSubmit: (data: string) =>
            props.dispatch(designRoutines.saveDesignRecord(data)),
        },
      }),
    ),
    onStepBackward: props => () => props.dispatch(designActions.stepBackward()),
    onStepForward: props => () => props.dispatch(designActions.stepForward()),
    onStepReset: props => () => props.dispatch(designActions.stepReset()),
    // onUndo: props => () => props.actions.()),
    onDuplicateDesign: (props: any) => id =>
      props.dispatch(
        designRoutines.copyDesign({
          id,
          name: `${props.designName}-${new Date().toISOString()}`,
        }),
      ),
    onUpdateDesign: (props: any) => () =>
      props.dispatch(designRoutines.updateDesign({ id: props.id })),
  }),
);

export default enhancer(DesignToolBar);



// WEBPACK FOOTER //
// ./src/components/DesignToolBar/DesignToolBar.js